<div class="page-container centered">
    <app-header [title]="'self-serve.greeting' | translate: { name: firstName }" class="header"> </app-header>

    <div>
        <app-tab-bar [menuService]="menuService"></app-tab-bar>
    </div>

    <app-self-serve-quickstart *ngIf="selected === 'quickstart'"></app-self-serve-quickstart>

    <app-inbox-viewer *ngIf="selected === 'inbox'"></app-inbox-viewer>
</div>
